"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.em = void 0;
exports.getValueAndUnit = getValueAndUnit;
exports.pxTo = pxTo;
exports.rem = void 0;
exports.toPx = toPx;
exports.widthFromColumns = widthFromColumns;
function toPx(value) {
  return `${value}px`;
}
function pxTo(unit) {
  return function (px) {
    let base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    return `${px / base}${unit}`;
  };
}
function widthFromColumns(columns) {
  let maxColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 24;
  if (columns > maxColumns) columns = maxColumns;
  return `calc(${columns} / ${maxColumns} * 100%)`;
}
const em = exports.em = pxTo('em');
const rem = exports.rem = pxTo('rem');

/**
 * Returns a given CSS value and its unit as elements of an array.
 * Source: https://github.com/styled-components/polished/blob/master/src/helpers/getValueAndUnit.js
 */
function getValueAndUnit(value) {
  if (typeof value !== 'string') {
    return [value, ''];
  }
  const matchedValue = value.match(cssValueAndUnitMatchingRegex);
  if (matchedValue) {
    return [parseFloat(value), matchedValue[2]];
  }
  return [value, undefined];
}
const cssValueAndUnitMatchingRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;